import React, { useCallback } from 'react';
import GridLayout from '../../../../shared/ui/GridLayout';
import Field from '../../../../shared/ui/Field';
import { useFieldController } from '../../../../../../helpers/formManager';
import { fieldNames } from '../../../../shared/configs/acceptanceForm';
import {
  dateTime,
  getDisabledDateForPicker,
} from '../../../../shared/packages/dateTime';

const FromBody = ({ control, fromDate, toDate, disabled, changeCb }) => {
  return (
    <>
      <GridLayout adaptive>
        <FromField
          control={control}
          defaultValue={fromDate}
          toDate={toDate}
          disabled={disabled}
          changeCb={changeCb}
        />
        <Field.Memoized
          type={Field.types.datePicker}
          formItemLabel="Дата окончания"
          value={toDate}
          disabled
        />
      </GridLayout>
    </>
  );
};

export default FromBody;

function FromField({ control, defaultValue, toDate, disabled, changeCb }) {
  const { field, fieldState } = useFieldController({
    name: fieldNames.main.fromDate,
    defaultValue,
    control,
    rules: {
      required: 'Укажите дату',
      validate: (value) => {
        if (!value) return;

        if (value.isSame(defaultValue, 'day')) {
          return 'Дата начала не изменена';
        }

        if (value.isSameOrBefore(dateTime(), 'day')) {
          return 'Дата начала не может быть раньше текущей даты';
        }
      },
    },
  });

  const disabledDate = useCallback(
    (date) => getDisabledDateForPicker(date, toDate),
    [toDate]
  );

  const handleChange = (date) => {
    field.onChange(date);
    changeCb();
  };

  return (
    <Field.Memoized
      type={Field.types.datePicker}
      formItemLabel="Дата начала"
      required
      errorMessage={fieldState.error?.message}
      disabledDate={disabledDate}
      value={field.value}
      onChange={handleChange}
      disabled={disabled}
    />
  );
}
